import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import FormInput from "../../FormInput";
import { getCurrentDateMysql } from "../../../util/generalUtills";

const sectionTitleStyle = { color: "#d10b0b", width: "100%" };

/** Add-time motor payload — compulsory sections only. */
export const buildMotorOdAddPayload = (formData) => ({
  claim_details: {
    claim_intimation_date: formData.motor_od_claim_intimation_date ?? null,
    date_of_loss: formData.motor_od_date_of_loss ?? null,
    time_of_accident: formData.motor_od_time_of_accident ?? null,
    location: formData.motor_od_location ?? null,
    vehicle: formData.motor_od_vehicle ?? null,
    idv: formData.motor_od_idv ?? null,
    date_of_allocation: formData.motor_od_date_of_allocation ?? null,
    trigger_for_investigation: formData.motor_od_trigger_for_investigation ?? null,
  },
  policy_details: {
    insured_name: formData.motor_od_insured_name ?? null,
    policy_type: formData.motor_od_policy_type ?? null,
    policy_period_from: formData.motor_od_policy_period_from ?? null,
    policy_period_to: formData.motor_od_policy_period_to ?? null,
    previous_insurer: formData.motor_od_previous_insurer ?? null,
    previous_policy_no: formData.motor_od_previous_policy_no ?? null,
    previous_policy_expiry_date: formData.motor_od_previous_policy_expiry_date ?? null,
  },
  rc_details: {
    registration_no: formData.motor_od_registration_no ?? null,
    owner_name: formData.motor_od_owner_name ?? null,
    address: formData.motor_od_rc_address ?? null,
    chassis_no: formData.motor_od_chassis_no ?? null,
    engine_no: formData.motor_od_engine_no ?? null,
    valid_till: formData.motor_od_valid_till ?? null,
  },
  insured_details: {
    name: formData.motor_od_insured_detail_name ?? null,
    occupation: formData.motor_od_insured_occupation ?? null,
    contact: formData.motor_od_insured_contact ?? null,
  },
});

const MotorCaseInitiatedAddFields = ({
  t,
  formData,
  inputHandler,
  inputDateHandler,
  inputTimeHandler,
  selectMobileHandler,
  errors,
}) => (
  <>
    <Row>
      <h3 style={sectionTitleStyle}>{t("1. Claim Details")}</h3>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Claim Intimation Date")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_claim_intimation_date}
            onChange={(value) => inputDateHandler("motor_od_claim_intimation_date", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_claim_intimation_date && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_claim_intimation_date}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Date of Loss")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_date_of_loss}
            onChange={(value) => inputDateHandler("motor_od_date_of_loss", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_date_of_loss && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_date_of_loss}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Time of Accident")}</Form.Label>
          <DatePicker
            selected={
              formData?.motor_od_time_of_accident
                ? new Date(`${getCurrentDateMysql()}T${formData.motor_od_time_of_accident}`)
                : null
            }
            onChange={(value) => inputTimeHandler("motor_od_time_of_accident", value)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="h:mm aa"
            className="form-control"
            withPortal
            isClearable
          />
          {errors?.motor_od_time_of_accident && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_time_of_accident}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Location")}
          type="text"
          placeholder={t("Enter Location")}
          errors={errors}
          value={formData.motor_od_location}
          name="motor_od_location"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Vehicle")}
          type="text"
          placeholder={t("Enter Vehicle")}
          errors={errors}
          value={formData.motor_od_vehicle}
          name="motor_od_vehicle"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("IDV")}
          type="text"
          placeholder={t("Enter IDV")}
          errors={errors}
          value={formData.motor_od_idv}
          name="motor_od_idv"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Date of Allocation")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_date_of_allocation}
            onChange={(value) => inputDateHandler("motor_od_date_of_allocation", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_date_of_allocation && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_date_of_allocation}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Trigger for Investigation")}
          type="text"
          placeholder={t("Enter Trigger for Investigation")}
          errors={errors}
          value={formData.motor_od_trigger_for_investigation}
          name="motor_od_trigger_for_investigation"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>
    </Row>

    <Row>
      <h3 style={sectionTitleStyle}>{t("2. Policy Details")}</h3>

      <Col lg={4}>
        <FormInput
          label={t("Insured Name")}
          type="text"
          placeholder={t("Enter Insured Name")}
          errors={errors}
          value={formData.motor_od_insured_name}
          name="motor_od_insured_name"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Policy Type")}
          type="text"
          placeholder={t("Enter Policy Type")}
          errors={errors}
          value={formData.motor_od_policy_type}
          name="motor_od_policy_type"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Policy Period From")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_policy_period_from}
            onChange={(value) => inputDateHandler("motor_od_policy_period_from", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_policy_period_from && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_policy_period_from}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Policy Period To")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_policy_period_to}
            onChange={(value) => inputDateHandler("motor_od_policy_period_to", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
            minDate={formData.motor_od_policy_period_from || undefined}
          />
          {errors?.motor_od_policy_period_to && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_policy_period_to}</p>
            </div>
          )}
        </Form.Group>
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Previous Insurer")}
          type="text"
          placeholder={t("Enter Previous Insurer")}
          errors={errors}
          value={formData.motor_od_previous_insurer}
          name="motor_od_previous_insurer"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Previous Policy No.")}
          type="text"
          placeholder={t("Enter Previous Policy No.")}
          errors={errors}
          value={formData.motor_od_previous_policy_no}
          name="motor_od_previous_policy_no"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Previous Policy Expiry Date")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_previous_policy_expiry_date}
            onChange={(value) => inputDateHandler("motor_od_previous_policy_expiry_date", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_previous_policy_expiry_date && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_previous_policy_expiry_date}</p>
            </div>
          )}
        </Form.Group>
      </Col>
    </Row>

    <Row>
      <h3 style={sectionTitleStyle}>{t("3. RC Details")}</h3>

      <Col lg={4}>
        <FormInput
          label={t("Registration No")}
          type="text"
          placeholder={t("Enter Registration No")}
          errors={errors}
          value={formData.motor_od_registration_no}
          name="motor_od_registration_no"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Owner Name")}
          type="text"
          placeholder={t("Enter Owner Name")}
          errors={errors}
          value={formData.motor_od_owner_name}
          name="motor_od_owner_name"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Address")}
          type="text"
          placeholder={t("Enter Address")}
          errors={errors}
          value={formData.motor_od_rc_address}
          name="motor_od_rc_address"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Chassis No")}
          type="text"
          placeholder={t("Enter Chassis No")}
          errors={errors}
          value={formData.motor_od_chassis_no}
          name="motor_od_chassis_no"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Engine No")}
          type="text"
          placeholder={t("Enter Engine No")}
          errors={errors}
          value={formData.motor_od_engine_no}
          name="motor_od_engine_no"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <Form.Group className="mb-3">
          <Form.Label>{t("Valid Till")}</Form.Label>
          <DatePicker
            selected={formData.motor_od_valid_till}
            onChange={(value) => inputDateHandler("motor_od_valid_till", value)}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            withPortal
            showYearDropdown
            scrollableYearDropdown
            showMonthDropdown
            scrollableMonthDropdown
            isClearable
          />
          {errors?.motor_od_valid_till && (
            <div className="invalid-feedback d-block">
              <p className="text-danger">{errors.motor_od_valid_till}</p>
            </div>
          )}
        </Form.Group>
      </Col>
    </Row>

    <Row>
      <h3 style={sectionTitleStyle}>{t("4. Insured Details")}</h3>

      <Col lg={4}>
        <FormInput
          label={t("Name")}
          type="text"
          placeholder={t("Enter Name")}
          errors={errors}
          value={formData.motor_od_insured_detail_name}
          name="motor_od_insured_detail_name"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Occupation")}
          type="text"
          placeholder={t("Enter Occupation")}
          errors={errors}
          value={formData.motor_od_insured_occupation}
          name="motor_od_insured_occupation"
          onChange={inputHandler}
          containerClass="mb-3"
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={t("Contact")}
          type="text"
          placeholder={t("Enter Contact")}
          errors={errors}
          value={formData.motor_od_insured_contact}
          name="motor_od_insured_contact"
          onChange={selectMobileHandler}
          containerClass="mb-3"
        />
      </Col>
    </Row>
  </>
);

export default MotorCaseInitiatedAddFields;
